export default __webpack_public_path__ + "static/media/logo.8d547d9a.svg";